import { render, staticRenderFns } from "./callPoliceSet.vue?vue&type=template&id=0890587b&scoped=true"
import script from "./callPoliceSet.vue?vue&type=script&lang=ts"
export * from "./callPoliceSet.vue?vue&type=script&lang=ts"
import style0 from "./callPoliceSet.vue?vue&type=style&index=0&id=0890587b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890587b",
  null
  
)

export default component.exports